import mainCaller from './mainCaller';

// 지점의 출입그룹 매핑 목록
export const listBranchAccessGroups = async (branchId, token) =>
  mainCaller(`admin/api/v1/branch-access-groups?branchId=${branchId}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });

// 신규 출입그룹 매핑 (UBio 그룹/단말 자동 연동)
export const createBranchAccessGroup = async (payload, token) =>
  mainCaller(`admin/api/v1/branch-access-groups`, 'POST', payload, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  });

// 출입그룹 상세 (회원목록 + 유효 수강권/이용권). filters.sportType / filters.category(TICKET|PASS)
export const getBranchAccessGroupDetail = async (id, token, filters = {}) => {
  const params = new URLSearchParams();
  if (filters.sportType) params.set('sportType', filters.sportType);
  if (filters.category) params.set('category', filters.category);
  const qs = params.toString();
  return mainCaller(
    `admin/api/v1/branch-access-groups/${id}${qs ? `?${qs}` : ''}`,
    'GET',
    null,
    { Authorization: `Bearer ${token}` }
  );
};

// 출입그룹 수정 (accessGroupCode 변경 시 회원 출입권 cascade)
export const updateBranchAccessGroup = async (id, payload, token) =>
  mainCaller(`admin/api/v1/branch-access-groups/${id}`, 'PUT', payload, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  });

// 매핑 비활성 (use_yn='N')
export const deleteBranchAccessGroup = async (id, token) =>
  mainCaller(`admin/api/v1/branch-access-groups/${id}`, 'DELETE', null, {
    Authorization: `Bearer ${token}`,
  });

// 매장 대표 sport 목록 (출입그룹 보유 여부 포함)
export const listBranchSports = async (branchId, token) =>
  mainCaller(`admin/api/v1/branch-access-groups/sports?branchId=${branchId}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });

// 지점 그룹(Group) 생성 — UBio Group 생성 + 종목별 행 생성·GROUP_ID 기록
export const createBranchGroup = async (branchId, groupName, token) => {
  const q = groupName ? `&groupName=${encodeURIComponent(groupName)}` : '';
  return mainCaller(
    `admin/api/v1/branch-access-groups/branch-group?branchId=${branchId}${q}`,
    'POST',
    null,
    { Authorization: `Bearer ${token}` }
  );
};

// 누락 종목 동기화 (UBio 출입그룹·출입구역 생성)
export const syncBranchAccessGroups = async (branchId, token) =>
  mainCaller(`admin/api/v1/branch-access-groups/sync?branchId=${branchId}`, 'POST', null, {
    Authorization: `Bearer ${token}`,
  });

// 출입그룹 단말 매핑 (UBio 출입구역에 단말 push)
export const mapBranchAccessGroupTerminals = async (id, terminalIds, token) =>
  mainCaller(`admin/api/v1/branch-access-groups/${id}/terminals`, 'POST', { terminalIds }, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  });

// 지점에 등록된 단말 distinct 목록
export const listBranchTerminals = async (branchId, token) =>
  mainCaller(`admin/api/v1/branch-access-groups/terminals?branchId=${branchId}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });

// 회원을 다른 출입그룹으로 이동 (UBio user group 갱신 + 단말 push)
export const moveBranchAccessGroupMember = async (payload, token) =>
  mainCaller(`admin/api/v1/branch-access-groups/members/move`, 'POST', payload, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  });

// 회원을 다른 출입그룹에 복사 (원본 유지 + 대상 그룹 UBio user 신규 발급 + 단말 push)
export const copyBranchAccessGroupMember = async (payload, token) =>
  mainCaller(`admin/api/v1/branch-access-groups/members/copy`, 'POST', payload, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  });
